import React, { useState, useEffect, useContext } from 'react';
import { Button, Card, CardContent, Container, TextField, Typography } from '@material-ui/core';
import bicycle from '../../assets/fuelex98gx_22_33074_a_primary (1).png';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Header/Header';
import { useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Modal, Paper, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';



const DetailsPage = ({ data }) => {

    const location = useLocation();
    const { pathname } = location;
    const [open, setOpen] = useState(false);
    const [textDailog, setTextDailog] = useState(false);
    const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleTextDailogOpen = () => {
        setTextDailog(true);
    }
    const handleTextDailogClose = () => {
        setTextDailog(false);
    }

    // var currentURL = window.location.href;
    // var lastNumber = currentURL.match(/\d+$/);
    // console.log('userid', window.localStorage.userID);




    const [state, setState] = useState({
        data: {},
        Chain: '',
        BottomBracket: '',
        pedals: '',
        chainrings: '',
        cranks: '',
        chainguide: '',
        ISCGTabs: '',
        wheelSize: '',
        fork: '',
        frontTravel: '',
        HubDimensions: '',
        rearShock: '',
        rearTravel: '',
        rearDropout: '',
        headtubeDiameter: '',
        headset: '',
        handlebar: '',
        handlebarRise: '',
        stem: '',
        grips: '',
        brakes: '',
        brakeLevers: '',
        frontDeraille: '',
        rearDeraille: '',
        MaxTireSize: '',
        seatpostClamp: '',
        seatpostDiameter: '',
        seatpostlength: '',
        seatpost: '',
        cassette: '',
        changeRims: '',
        hubs: '',
        spokes: '',
        tireFront: '',
        tireRear: '',
        saddle: '',
        forkPSI_HSC: '',
        forkPSI_HSR: '',
        forkPSI_LSC: '',
        forkPSI_LSR: '',
        shockPSI_HSC: '',
        shockPSI_HSR: '',
        shockPSI_LSC: '',
        shockPSI_LSR: '',
        coilLbs: '',
        frontTirePSI: '',
        rearTirePSI: ''

    });

    const [warningFHSC, setWarningFHSC] = useState('');
    const [warningFHSR, setWarningFHSR] = useState('');
    const [warningFLSC, setWarningFLSC] = useState('');
    const [warningFLSR, setWarningFLSR] = useState('');
    const [warningSHSC, setWarningSHSC] = useState('');
    const [warningSHSR, setWarningSHSR] = useState('');
    const [warningSLSC, setWarningSLSC] = useState('');
    const [warningSLSR, setWarningSLSR] = useState('');
    const [warningCL, setWarningCL] = useState('');
    const [warningFT, setWarningFT] = useState('');
    const [warningRT, setWarningRT] = useState('');

    const [userData, setUserData] = useState([]);
    const [height, setHeight] = useState();
    const [weight, setWeight] = useState();
    const [skill, setSkill] = useState();
    const [discipline, setDiscipline] = useState();
    const [inseam, setInseam] = useState();
    const [reach, setReach] = useState();
    const [name, setName] = useState();




    useEffect(() => {
        console.log('username', userData)
        updateUser(window.localStorage.userID)
        const path = window.location.pathname;
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const selectedYear = path.split('/')[2];
        const selectedMake = path.split('/')[3].split('_').join(" ");
        const selectedModel = path.split('/')[4].split('_').join(" ");
        const selectedTrim = path.split('/')[5].split('_').join(" ");
        const requestData = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            trim: selectedTrim,
        };


        console.log('od', state.data.id)



        axios.post(process.env.REACT_APP_BASE_URL + 'product/getBicycleByValues', requestData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((response) => {
            if (response.status === 200) {
                setState((prevState) => ({
                    ...prevState,
                    data: response.data.bicycle,
                }));
            }
        })
            .catch((error) => {
                console.error('Error:', error);
            });






    }, []);

    const signData = {
        name: state.suserName,
        email: state.semail,
        password: state.spassword,
    };



    const headleSingUPUpModal = () => {
        axios.post(process.env.REACT_APP_BASE_URL + 'users/register', signData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((response) => {
            // navigate('/your-bicycle', { state: { bicycle: response.data.bicycle } });
            console.log('aaaaaaaaaaaaaaaa', response.status);
            if (response.status === 201) {
                window.localStorage.setItem("token", response.data.token);
                window.localStorage.setItem("userID", response.data.user.id);
                closeSignUpModal();
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

                // window.localStorage.setItem("token", response.data.token);

            } else {
                closeSignUpModal();
                toast.error(response.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        })
            .catch((error) => {
                closeSignUpModal();
                toast.error(error.response.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }



    const requestData = {
        email: state.userName,
        password: state.password,
    };

    const headleloginUpModal = () => {
        axios.post(process.env.REACT_APP_BASE_URL + 'users/login', requestData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((response) => {
            // navigate('/your-bicycle', { state: { bicycle: response.data.bicycle } });
            console.log('aaaaaaaaaaaaaaaa', response.data);
            if (response.status === 200) {
                window.location.reload()
                window.localStorage.setItem("token", response.data.token);
                window.localStorage.setItem("userID", response.data.user.id);
                closeLoginModal();
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                closeLoginModal();
                toast.error(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        })
            .catch((error) => {
                // console.error('Error:', error);
                closeLoginModal();
                toast.error(error.response.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }


    const openSignUpModal = () => {
        setSignUpModalOpen(true);
        handleClose();
    };


    const closeSignUpModal = () => {
        setSignUpModalOpen(false);
    };

    const handleChangeSingUserName = (event) => {
        setState((prevState) => ({
            ...prevState,
            suserName: event.target.value,
        }));
    }

    const handleChangeSingemailName = (event) => {
        setState((prevState) => ({
            ...prevState,
            semail: event.target.value,
        }));
    }

    const handleChangeSingPassword = (event) => {
        setState((prevState) => ({
            ...prevState,
            spassword: event.target.value,
        }));
    }

    const openLoginModal = () => {
        setLoginModalOpen(true);
        handleClose();
    };

    const closeLoginModal = () => {
        setLoginModalOpen(false);
    };

    const handleChangeUserName = (event) => {
        setState((prevState) => ({
            ...prevState,
            userName: event.target.value,
        }));
    }

    const handleChangePassword = (event) => {
        setState((prevState) => ({
            ...prevState,
            password: event.target.value,
        }));
    }

    const handleChangeChain = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                chain: event.target.value,
            },
        }));
    }


    const handleChangeCassette = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                cassette: event.target.value,
            },
        }));
    }

    const handleChangeSeatpost = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                seatPost: event.target.value,
            },
        }));
    }


    const handleChangeRims = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                rims: event.target.value,
            },
        }));
    }


    const handleChangeHubs = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                hubs: event.target.value,
            },
        }));
    }


    const handleChangeSpokes = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                spokes: event.target.value,
            },
        }));
    }


    const handleChangeTireFront = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                tireFront: event.target.value,
            },
        }));
    }


    const handleChangeTireRear = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                tireRear: event.target.value,
            },
        }));
    }


    const handleChangeSaddle = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                saddle: event.target.value,
            },
        }));
    }

    const handleChangeseatpostlength = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                seatPostLength: event.target.value,
            },
        }));
    }

    const handleChangeSeatpostDiameter = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                seatpostDiameter: event.target.value,
            },
        }));
    }


    const handleChangeSeatpostClamp = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                seatpostClamp: event.target.value,
            },
        }));
    }

    const handleChangeMaxTireSize = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                maxTireSize: event.target.value,
            },
        }));
    }
    const handleChangeBottomBracket = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                bottomBracket: event.target.value,
            },
        }));
    }
    const handleChangePedals = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                pedals: event.target.value,
            },
        }));
    }

    const handleChangeCranks = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                cranks: event.target.value,
            },
        }));
    }

    const handleChangeChainrings = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                chainRings: event.target.value,
            },
        }));
    }

    const handleChangeChainguide = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                chainGuide: event.target.value,
            },
        }));
    }
    const handleChangeISCGTabs = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                ISCGTabs: event.target.value,
            },
        }));
    }

    const handleChangewheelSize = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                wheelSize: event.target.value,
            },
        }));
    }

    const handleChangeframeMaterial = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                frameMaterial: event.target.value,
            },
        }));
    }


    const handleChangefrontTravel = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                frontTravel: event.target.value,
            }
        }));
    }

    const handleChangeFork = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                fork: event.target.value,
            },
        }));
    };


    const handleChangeHubDimensions = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                forkDropoutHubDimensions: event.target.value,
            },
        }));
    }


    const handleChangerearShock = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                rearShock: event.target.value,
            },
        }));
    }


    const handleChangerearTravel = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                rearTravel: event.target.value,
            },
        }));
    }



    const handleChangerearDropout = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                rearDropoutHubDimensions: event.target.value,
            },
        }));
    }


    const handleChangeheadtubeDiameter = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                headtubeDiameter: event.target.value,
            },
        }));
    }


    const handleChangeHeadset = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                headset: event.target.value,
            },
        }));
    }


    const handleChangeHandlebar = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                handleBar: event.target.value,
            },
        }));
    }


    const handleChangehandlebarRise = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                handleBarRise: event.target.value,
            },
        }));
    }


    const handleChangeStem = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                stem: event.target.value,
            },
        }));
    }
    const handleChangeGrips = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                grips: event.target.value,
            },
        }));
    }


    const handleChangeBrakes = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                brakes: event.target.value,
            },
        }));
    }


    const handleChangeBrakeLevers = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                brakeLevers: event.target.value,
            },
        }));
    }


    const handleChangeFrontDeraille = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                frontDerailleur: event.target.value,
            },

        }));
    }


    const handleChangeRearDerailleur = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                rearDerailleur: event.target.value,
            },
        }));
    }
    const handleShifters = (event) => {
        setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                shifters: event.target.value,
            },
        }));
    }
    const handleForkPsiHsc = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_HSC: parseInt(inputValue),
                },
            }));

            setWarningFHSC('');
        }

        else {

            setWarningFHSC('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_HSC: '',
                },
            }));
        }
    };



    const handleForkPsiHsr = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_HSR: parseInt(inputValue),
                },
            }));

            setWarningFHSR('');
        }

        else {

            setWarningFHSR('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_HSR: '',
                },
            }));
        }
    };


    const handleForkPsiLsc = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_LSC: parseInt(inputValue),
                },
            }));

            setWarningFLSC('');
        }

        else {

            setWarningFLSC('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_LSC: '',
                },
            }));
        }
    };


    const handleForkPsiLsr = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_LSR: parseInt(inputValue),
                },
            }));

            setWarningFLSR('');
        }

        else {

            setWarningFLSR('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    forkPSI_LSR: '',
                },
            }));
        }
    };


    const handleShockPsiHsc = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_HSC: parseInt(inputValue),
                },
            }));

            setWarningSHSC('');
        }

        else {

            setWarningSHSC('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_HSC: '',
                },
            }));
        }
    };


    const handleShockPsiHsr = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_HSR: parseInt(inputValue),
                },
            }));

            setWarningSHSR('');
        }

        else {

            setWarningSHSR('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_HSR: '',
                },
            }));
        }
    };


    const handleShockPsiLsc = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_LSC: parseInt(inputValue),
                },
            }));

            setWarningSLSC('');
        }

        else {

            setWarningSLSC('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_LSC: '',
                },
            }));
        }
    };

    const handleShockPsiLsr = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_LSR: parseInt(inputValue),
                },
            }));

            setWarningSLSR('');
        }

        else {

            setWarningSLSR('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    shockPSI_LSR: '',
                },
            }));
        }
    };



    const handleCoilLbs = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 999) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    coilLbs: parseInt(inputValue),
                },
            }));

            setWarningCL('');
        }

        else {

            setWarningCL('Please enter a valid three-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    coilLbs: '',
                },
            }));
        }
    };


    const handleFrontTirePSI = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    frontTirePSI: parseInt(inputValue),
                },
            }));

            setWarningFT('');
        }

        else {

            setWarningFT('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    frontTirePSI: '',
                },
            }));
        }
    };


    const handleRearTirePSI = (event) => {

        const inputValue = event.target.value;
        const intValue = parseInt(inputValue);


        if (!isNaN(intValue) && intValue >= 0 && intValue <= 99) {
            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    rearTirePSI: parseInt(inputValue),
                },
            }));

            setWarningRT('');
        }

        else {

            setWarningRT('Please enter a valid two-digit integer.');

            setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    rearTirePSI: '',
                },
            }));
        }
    };




    const handleHeightChange = (e) => {
        const inputValue = e.target.value;

        // Check if the entered value is an integer or empty
        if (/^\d*$/.test(inputValue)) {
            // Parse the input value as an integer or set an empty string
            setHeight(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };


    const handleWeightChange = (e) => {
        const inputValue = e.target.value;

        // Check if the entered value is an integer or empty
        if (/^\d*$/.test(inputValue)) {
            // Parse the input value as an integer or set an empty string
            setWeight(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };


    const handleInseamChange = (e) => {
        const inputValue = e.target.value;


        if (/^\d*$/.test(inputValue)) {

            setInseam(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };
    const handleReachChange = (e) => {
        const inputValue = e.target.value;


        if (/^\d*$/.test(inputValue)) {

            setReach(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };









    // const updateData = {
    //     id: parseInt(lastNumber[0]),
    //     userId: parseInt(window.localStorage.userID),
    //     make: state.data.make,
    //     model: state.data.model,
    //     year: state.data.year,
    //     modelTrim: state.data.modelTrim,
    //     wheelSize: state.data.wheelSize,
    //     frameMaterial: state.data.frameMaterial,
    //     fork: state.data.fork,
    //     frontTravel: state.data.frontTravel,
    //     forkDropoutHubDimensions: state.data.forkDropoutHubDimensions,
    //     rearShock: state.data.rearShock,
    //     rearTravel: state.data.rearTravel,
    //     rearDropoutHubDimensions: state.data.rearDropoutHubDimensions,
    //     headTubeDiameter: state.data.headTubeDiameter,
    //     headset: state.data.headset,
    //     handleBar: state.data.handleBar,
    //     handleBarRise: state.data.handleBarRise,
    //     stem: state.data.stem,
    //     grips: state.data.grips,
    //     brakes: state.data.brakes,
    //     brakeLevers: state.data.brakeLevers,
    //     frontDerailleur: state.data.frontDerailleur,
    //     rearDerailleur: state.data.rearDerailleur,
    //     shifters: state.data.shifters,
    //     iscgTabs: state.data.iscgTabs,
    //     chainGuide: state.data.chainGuide,
    //     cranks: state.data.cranks,
    //     chainRings: state.data.chainRings,
    //     bottomBracket: state.data.bottomBracket,
    //     pedals: state.data.pedals,
    //     chain: state.data.chain,
    //     cassette: state.data.cassette,
    //     rims: state.data.rims,
    //     hubs: state.data.hubs,
    //     spokes: state.data.spokes,
    //     tireFront: state.data.tireFront,
    //     tireRear: state.data.tireRear,
    //     saddle: state.data.saddle,
    //     seatPost: state.data.seatPost,
    //     seatPostLength: state.data.seatPostLength,
    //     seatPostDiameter: state.data.seatPostDiameter,
    //     seatPostClamp: state.data.seatPostClamp,
    //     MaxTireSize: state.data.MaxTireSize,
    //     bottleCageMounts: state.data.bottleCageMounts,
    //     colors: state.data.colors,
    //     weight: state.data.weight,
    //     imageUrl: state.data.imageUrl

    //     // username: state.suserName,
    //     // email: state.semail,
    //     // password: state.spassword,
    // };


    const srequestData = {
        id: state.data.id,
        make: state.data.make,
        model: state.data.model,
        year: state.data.year,
        modelTrim: state.data.modelTrim,
        wheelSize: state.data.wheelSize,
        frameMaterial: state.data.frameMaterial,
        fork: state.data.fork,
        frontTravel: state.data.frontTravel,
        forkDropoutHubDimensions: state.data.forkDropoutHubDimensions,
        rearShock: state.data.rearShock,
        rearTravel: state.data.rearTravel,
        rearDropoutHubDimensions: state.data.rearDropoutHubDimensions,
        headTubeDiameter: state.data.headTubeDiameter,
        headset: state.data.headset,
        handleBar: state.data.handleBar,
        handleBarRise: state.data.handleBarRise,
        stem: state.data.stem,
        grips: state.data.grips,
        brakes: state.data.brakes,
        brakeLevers: state.data.brakeLevers,
        frontDerailleur: state.data.frontDerailleur,
        rearDerailleur: state.data.rearDerailleur,
        shifters: state.data.shifters,
        iscgTabs: state.data.iscgTabs,
        chainGuide: state.data.chainGuide,
        cranks: state.data.cranks,
        chainRings: state.data.chainRings,
        bottomBracket: state.data.bottomBracket,
        pedals: state.data.pedals,
        chain: state.data.chain,
        cassette: state.data.cassette,
        rims: state.data.rims,
        hubs: state.data.hubs,
        spokes: state.data.spokes,
        tireFront: state.data.tireFront,
        tireRear: state.data.tireRear,
        saddle: state.data.saddle,
        seatPost: state.data.seatPost,
        seatPostLength: state.data.seatPostLength,
        seatPostDiameter: state.data.seatPostDiameter,
        seatPostClamp: state.data.seatPostClamp,
        MaxTireSize: state.data.MaxTireSize,
        bottleCageMounts: state.data.bottleCageMounts,
        colors: state.data.colors,
        weight: state.data.weight,
        imageUrl: state.data.imageUrl,
        forkPSI_HSC: state.data.forkPSI_HSC,
        forkPSI_HSR: state.data.forkPSI_HSR,
        forkPSI_LSC: state.data.forkPSI_LSC,
        forkPSI_LSR: state.data.forkPSI_LSR,
        shockPSI_HSC: state.data.shockPSI_HSC,
        shockPSI_HSR: state.data.shockPSI_HSR,
        shockPSI_LSC: state.data.shockPSI_LSC,
        shockPSI_LSR: state.data.shockPSI_LSR,
        coilLbs: state.data.coilLbs,
        frontTirePSI: state.data.frontTirePSI,
        rearTirePSI: state.data.rearTirePSI,


        // username: state.suserName,
        // email: state.semail,
        // password: state.spassword,
    };


    const openLogoutModal = (event) => {
        console.log(state, 'data');
        axios.post(process.env.REACT_APP_BASE_URL + 'product/saveBicycleForUser', srequestData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': window.localStorage.getItem("token")
            },
        }).then((response) => {
            console.log(response, 'resssss')
            if (response.status === 200 || response.status === 201) {
                if (response.data === "You already saved 3 Bicycles for your Account") {
                    toast.error(response.data, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {

                    toast.success(response.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                }


                // window.localStorage.setItem("token", response.data.token);

            } else {
                toast.error(response.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        })
            .catch((error) => {
                toast.error(error.response.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }

    // const showAlert = () => {
    //     alert('You have to log in first.');
    // }


    // const handleUpdateBicycleForUser = () => {
    //     axios.post(
    //         process.env.REACT_APP_BASE_URL + 'product/updateBicycleForUser', updateData,
    //         {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': window.localStorage.getItem("token")
    //             }
    //         }
    //     )
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 console.log('successssssss', response)
    //             }
    //         })
    //         .catch((error) => {
    //             console.log('err', error);
    //         });
    // };
    // // console.log('data', state.data.id);

    const [isLoggedIn, setLoggedIn] = useState(false);

    // Function to handle login
    const handleLogin = () => {
        // Perform your login logic here
        // For example, setLoggedIn(true);
        setLoggedIn(true);
    };

    // Function to handle logout
    const handleLogout = () => {
        // Perform your logout logic here
        // For example, setLoggedIn(false);
        setLoggedIn(false);
    };

    console.log('isLoggedIn', isLoggedIn)

    console.log('wwww', window.localStorage.getItem("token"))


    const updateUser = (idToUpdateUser) => {
        axios.post(
            process.env.REACT_APP_BASE_URL + 'users/update-user',
            {
                id: idToUpdateUser,
                height: height,
                weight: weight,
                skill: skill,
                discipline: discipline,
                inseam: inseam,
                reach: reach,
                name: name

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': window.localStorage.getItem("token")
                }
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    // If the deletion is successful, fetch the updated data

                    setUserData(response.data);
                    setHeight(response.data.height)
                    setWeight(response.data.weight)
                    setSkill(response.data.skill)
                    setDiscipline(response.data.discipline)
                    setInseam(response.data.inseam)
                    setReach(response.data.reach)
                    setName(response.data.name)

                }
            })
            .catch((error) => {
                console.log('err', error);
            });
    };






    return (
        <div>

            {state.data ? (
                <>
                    <Header />
                    <Container className="mt-5 single-product-page-hero">
                        <Typography variant="h1" component="h1">{state.data?.year} {state.data?.make} {state.data?.model} {state.data?.modelTrim}</Typography>
                        <div className="bicyle-image-container"><img src={bicycle} width="75%"></img></div>

                        {window.localStorage.getItem("token") ? (
                            <>
                                {/* <Card className="user-bio">

                                    <CardContent>
                                        <Typography variant="h5" gutterBottom align="center" style={{ color: '#0074BC', fontWeight: 'bold' }}>My Info</Typography>
                                        <Typography variant="h6" gutterBottom>Name:
                                            <TextField value={userData?.name === '' ? '' : name} onChange={(e) => setName(e.target.value)} />
                                        </Typography>

                                        <Typography variant="h6" gutterBottom>Height:
                                            <TextField
                                                value={userData?.height === '' ? '' : height}
                                                onChange={handleHeightChange}
                                                placeholder="Enter integer value"
                                            />
                                        </Typography>

                                        <Typography variant="h6" gutterBottom>Weight:
                                            <TextField
                                                value={userData?.weight === '' ? '' : weight}
                                                onChange={handleWeightChange}
                                                placeholder="Enter integer value"
                                            />
                                        </Typography>

                                        <Typography variant="h6" gutterBottom>Reach:
                                            <TextField
                                                value={userData?.reach === '' ? '' : reach}
                                                onChange={handleReachChange}
                                                placeholder="Enter integer value"
                                            />
                                        </Typography>

                                        <Typography variant="h6" gutterBottom>Inseam:
                                            <TextField
                                                value={userData?.inseam === '' ? '' : inseam}
                                                onChange={handleInseamChange}
                                                placeholder="Enter integer value"
                                            />
                                        </Typography>
                                        <Typography variant="h6" gutterBottom>Skill:
                                            <TextField value={userData?.skill === '' ? '' : skill} onChange={(e) => setSkill(e.target.value)} />
                                        </Typography>
                                        <Typography variant="h6" gutterBottom>Discipline:
                                            <TextField value={userData?.discipline === '' ? '' : discipline} onChange={(e) => setDiscipline(e.target.value)} />
                                        </Typography>

                                        <Button
                                            className='m-3'
                                            variant="contained"
                                            onClick={() => {
                                                updateUser(window.localStorage.userID)
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </CardContent>
                                </Card> */}
                            </>
                        ) : (
                            <>

                            </>
                        )}

                        {window.localStorage.getItem("token") ? (
                            <>
                                {/* <Card className="bike-bio">
                                    <CardContent>
                                        <Typography variant="h5" gutterBottom align="center" style={{ color: '#0074BC', fontWeight: 'bold' }}>Bike Setup</Typography>
                                        <Typography variant="h6" gutterBottom className='main'>Fork psi</Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>HSC:  <TextField
                                            value={state.data.forkPSI_HSC}
                                            width="50px"
                                            onChange={handleForkPsiHsc}
                                        />
                                            {warningFHSC && <div style={{ color: 'red' }}>{warningFHSC}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>HSR: <TextField
                                            value={state.data.forkPSI_HSR}
                                            width="50px"
                                            onChange={handleForkPsiHsr}
                                        />
                                            {warningFHSR && <div style={{ color: 'red' }}>{warningFHSR}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>LSC: <TextField
                                            value={state.data.forkPSI_LSC}
                                            width="50px"
                                            onChange={handleForkPsiLsc}
                                        />
                                            {warningFLSC && <div style={{ color: 'red' }}>{warningFLSC}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>LSR: <TextField
                                            value={state.data.forkPSI_LSR}
                                            width="50px"
                                            onChange={handleForkPsiLsr}
                                        />
                                            {warningFLSR && <div style={{ color: 'red' }}>{warningFLSR}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='main'>Shock psi</Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>HSC: <TextField
                                            value={state.data.shockPSI_HSC}
                                            width="50px"
                                            onChange={handleShockPsiHsc}
                                        />
                                            {warningSHSC && <div style={{ color: 'red' }}>{warningSHSC}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>HSR: <TextField
                                            value={state.data.shockPSI_HSR}
                                            width="50px"
                                            onChange={handleShockPsiHsr}
                                        />
                                            {warningSHSR && <div style={{ color: 'red' }}>{warningSHSR}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>LSC: <TextField
                                            value={state.data.shockPSI_LSC}
                                            width="50px"
                                            onChange={handleShockPsiLsc}
                                        />
                                            {warningSLSC && <div style={{ color: 'red' }}>{warningSLSC}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>LSR: <TextField
                                            value={state.data.shockPSI_LSR}
                                            width="50px"
                                            onChange={handleShockPsiLsr}
                                        />
                                            {warningSLSR && <div style={{ color: 'red' }}>{warningSLSR}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='sub'>Coil lbs: <TextField
                                            value={state.data.coilLbs}
                                            width="50px"
                                            onChange={handleCoilLbs}
                                        />
                                            {warningCL && <div style={{ color: 'red' }}>{warningCL}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='main'>Front tire psi: <TextField
                                            value={state.data.frontTirePSI}
                                            width="50px"
                                            onChange={handleFrontTirePSI}
                                        />
                                            {warningFT && <div style={{ color: 'red' }}>{warningFT}</div>}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom className='main'>Rear tire psi:  <TextField
                                            value={state.data.rearTirePSI}
                                            width="50px"
                                            onChange={handleRearTirePSI}
                                        />
                                            {warningRT && <div style={{ color: 'red' }}>{warningRT}</div>}
                                        </Typography>
                                    </CardContent>

                                </Card> */}
                            </>
                        ) : (
                            <>

                            </>
                        )}



                    </Container>
                    <Container className="specifications-container">
                        {/* -------------------------------------Specifications----------------------------------------------- */}
                        <Typography variant="h4" component="h4" >Specifications</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Product Make</td>
                                        <td>{(state.data.make)}</td>
                                    </tr>



                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>



                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>


                                </table>
                            </div>
                        </div>

                        {/* ---------------------------------------Cockpit----------------------------------------------------- */}

                        <Typography variant="h4" component="h4" >Cockpit</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Brakes</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.brakes}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeBrakes}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>Handlebar Rise</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.handleBarRise}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangehandlebarRise}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Seatpost</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.seatPost}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeSeatpost}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Grips</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.grips}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeGrips}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>





                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Brake Levers</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.brakeLevers}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeBrakeLevers}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Stem</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.stem}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeStem}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Seatpost Diameter</td>
                                        <td>{state.data.seatPostDiameter}</td>
                                    </tr>
                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Handlebar</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.handleBar}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeHandlebar}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Saddle</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.saddle}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeSaddle}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Seatpost Clamp</td>
                                        <td>{state.data.seatPostClamp}</td>
                                    </tr>


                                </table>
                            </div>
                        </div>

                        {/* ---------------------------------------Drivetrain----------------------------------------------------- */}

                        <Typography variant="h4" component="h4" >Drivetrain</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Front Derailleur</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.frontDerailleur}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeFrontDeraille}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>



                                    <tr>
                                        <td>Cranks</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.cranks}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeCranks}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Chain</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.chain}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeChain}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>





                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Rear Derailleur</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.rearDerailleur}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeRearDerailleur}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chainrings</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.chainRings}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeChainrings}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Cassette</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.cassette}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeCassette}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Shifters</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.shifters}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleShifters}

                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Bottom Bracket</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.bottomBracket}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeBottomBracket}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Pedals</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.pedals}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangePedals}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>




                                </table>
                            </div>
                        </div>

                        {/* ---------------------------------------Frame----------------------------------------------------- */}

                        <Typography variant="h4" component="h4" >Frame</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Product Model</td>
                                        <td>{state.data.model}</td>
                                    </tr>

                                    <tr>
                                        <td>Frame Material</td>
                                        <td>{state.data.frameMaterial}</td>
                                    </tr>

                                    <tr>
                                        <td>ISCG Tabs</td>
                                        <td>{state.data.iscgTabs}</td>
                                    </tr>



                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '50%' }} />
                                        <col style={{ width: '50%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Product Year</td>
                                        <td>{state.data.year}</td>
                                    </tr>
                                    <tr>
                                        <td>Head Tube Diameter</td>
                                        <td>{state.data.headTubeDiameter}</td>
                                    </tr>

                                    <tr>
                                        <td>Chainguide</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.chainGuide}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeChainguide}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>


                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Product Model Trim</td>
                                        <td>{state.data.modelTrim}</td>
                                    </tr>

                                    <tr>
                                        <td>Headset</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.headset}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeHeadset}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Seatpost length</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.seatPostLength}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeseatpostlength}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>





                                </table>
                            </div>
                        </div>


                        {/* ---------------------------------------Suspension----------------------------------------------------- */}

                        <Typography variant="h4" component="h4" >Suspension</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Fork</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.fork}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeFork}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Rear Travel</td>
                                        <td>{state.data.rearTravel}</td>
                                    </tr>


                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Front Travel</td>
                                        <td>{state.data.frontTravel}</td>
                                    </tr>





                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Rear Shock</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.rearShock}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangerearShock}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>






                                </table>
                            </div>
                        </div>

                        {/* ---------------------------------------Wheels----------------------------------------------------- */}

                        <Typography variant="h4" component="h4" >Wheels</Typography>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* First Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tr>
                                        <td>Wheel Size</td>
                                        <td>{state.data.wheelSize}</td>
                                    </tr>

                                    <tr>
                                        <td>Rims</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.rims}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeRims}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Tire Front</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.tireFront}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeTireFront}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>





                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Fork Dropout / Hub Dimensions</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.forkDropoutHubDimensions}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeHubDimensions}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Hubs</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.hubs}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeHubs}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Tire Rear</td>
                                        <td>
                                            <TextField
                                                // disabled={true}
                                                value={state.data.tireRear}
                                                fullWidth
                                                onClick={handleTextDailogOpen}
                                            // onChange={handleChangeTireRear}
                                            // Add other props as needed
                                            />
                                        </td>
                                    </tr>









                                </table>
                            </div>
                            <div style={{ flex: '1', marginRight: '20px' }}>
                                <table>
                                    {/* Second Column */}
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>

                                    <tr>
                                        <td>Rear Dropout / Hub Dimensions</td>
                                        <td>{state.data.rearDropoutHubDimensions} </td>
                                    </tr>

                                    <tr>
                                        <td>Spokes</td>
                                        <td>{state.data.spokes}</td>
                                    </tr>



                                    <tr>
                                        <td>Max. Tire Size</td>
                                        <td>{state.data.MaxTireSize}</td>
                                    </tr>



                                </table>
                            </div>
                        </div>


                        <Dialog open={textDailog} onClose={handleTextDailogClose}>
                            <DialogTitle>Cannot Edit.</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    You need add to MyStable first.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleTextDailogClose} color="primary">
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {window.localStorage.getItem("token") ? (

                            <Button style={{ display: pathname.includes('/edit-details') == true ? 'none' : 'block' }} class="add-to-stable-button" color="inherit" onClick={openLogoutModal}>
                                Add to MyStable
                            </Button>

                        ) : (
                            <>
                                {/* <Button style={{ display: pathname.includes('/edit-details') == true ? 'none' : 'block' }} class="add-to-stable-button" color="inherit" onClick={showAlert}>
                                    Add to MyStable
                                </Button> */}
                                <div>
                                    <Button
                                        style={{ display: pathname.includes('/edit-details') === true ? 'none' : 'block' }}
                                        class="add-to-stable-button"
                                        color="inherit"
                                        onClick={handleOpen}
                                    >
                                        Add to MyStable
                                    </Button>

                                    <Dialog open={open} onClose={handleClose}>
                                        <DialogTitle>You have to log in first.</DialogTitle>
                                        <DialogContent>
                                            <DialogContentText>
                                                Please log in or sign up to perform this action.
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={openLoginModal} color="primary">
                                                Login
                                            </Button>
                                            <Button onClick={openSignUpModal} color="primary">
                                                Sign Up
                                            </Button>
                                            <Button onClick={handleClose} color="primary">
                                                OK
                                            </Button>
                                        </DialogActions>
                                    </Dialog>


                                </div>

                            </>
                        )}

                    </Container>
                </>
            ) : (
                <>
                    <Container className="single-product-page-hero">
                        <Typography variant="h1" component="h1">2023 Trek Fuel EX 9.8 GX</Typography>


                        <div className="bicyle-image-container"><img src={bicycle} width="1000"></img></div>
                    </Container>
                    <Container className="specifications-container">
                        <Typography variant="h4" component="h4" >Specifications</Typography>
                        <table>
                            <colgroup>
                                <col style={{ width: '20%' }} />
                                <col style={{ width: '80%' }} />
                            </colgroup>

                            <tr>
                                <td>Product Make</td>
                                <td>Trek</td>
                            </tr>
                            <tr>
                                <td>Product Model</td>
                                <td>Fuel EX 9.8</td>
                            </tr>
                            <tr>
                                <td>Product Year</td>
                                <td>2023</td>
                            </tr>
                            <tr>
                                <td>Product Model Trim</td>
                                <td>Detailspage</td>
                            </tr>
                            <tr>
                                <td>Wheel Size</td>
                                <td>29&quot;</td>
                            </tr>
                            <tr>
                                <td>Frame Material</td>
                                <td>Carbon</td>
                            </tr>
                            <tr>
                                <td>Fork</td>
                                <td>FOX 34 Float Performance Elite</td>
                            </tr>
                            <tr>
                                <td>Front Travel</td>
                                <td>130mm</td>
                            </tr>
                            <tr>
                                <td>Fork Dropout / Hub Dimensions</td>
                                <td>15x110mm</td>
                            </tr>
                            <tr>
                                <td>Rear Shock</td>
                                <td>FOX Float DPX2 Performance Elite</td>
                            </tr>
                            <tr>
                                <td>Rear Travel</td>
                                <td>120mm</td>
                            </tr>
                            <tr>
                                <td>Rear Dropout / Hub Dimensions</td>
                                <td>12x148mm</td>
                            </tr>
                            <tr>
                                <td>Head Tube Diameter</td>
                                <td>1.5 inches</td>
                            </tr>
                            <tr>
                                <td>Headset</td>
                                <td>Integrated</td>
                            </tr>
                            <tr>
                                <td>Handlebar</td>
                                <td>780mm</td>
                            </tr>
                            <tr>
                                <td>Handlebar Rise</td>
                                <td>15mm</td>
                            </tr>
                            <tr>
                                <td>Stem</td>
                                <td>100mm</td>
                            </tr>
                            <tr>
                                <td>Brakes</td>
                                <td>SRAM Guide T</td>
                            </tr>
                            <tr>
                                <td>Brake Levers</td>
                                <td>SRAM Code R</td>
                            </tr>
                            <tr>
                                <td>Front Derailleur</td>
                                <td>SRAM XT</td>
                            </tr>
                            <tr>
                                <td>Rear Derailleur</td>
                                <td>SRAM GX</td>
                            </tr>
                            <tr>
                                <td>Shifters</td>
                                <td>SRAM GX</td>
                            </tr>
                            <tr>
                                <td>ISCG Tabs</td>
                                <td>ISCG 05</td>
                            </tr>
                            <tr>
                                <td>Chainguide</td>
                                <td>e*thirteen LG1</td>
                            </tr>
                            <tr>
                                <td>Cranks</td>
                                <td>SRAM GX</td>
                            </tr>
                            <tr>
                                <td>Chainrings</td>
                                <td>32T</td>
                            </tr>
                            <tr>
                                <td>Bottom Bracket</td>
                                <td>SRAM DUB</td>
                            </tr>
                            <tr>
                                <td>Chain</td>
                                <td>SRAM GX</td>
                            </tr>
                            <tr>
                                <td>Cassette</td>
                                <td>SRAM PG-1230 Eagle</td>
                            </tr>
                            <tr>
                                <td>Rims</td>
                                <td>DT Swiss X1900</td>
                            </tr>
                            <tr>
                                <td>Hubs</td>
                                <td>DT Swiss 370</td>
                            </tr>
                            <tr>
                                <td>Spokes</td>
                                <td>28 spokes</td>
                            </tr>
                            <tr>
                                <td>Tire Front</td>
                                <td>Maxxis Minion DHF 29x2.5</td>
                            </tr>
                            <tr>
                                <td>Tire Rear</td>
                                <td>Maxxis Minion DHR II 29x2.5</td>
                            </tr>
                            <tr>
                                <td>Saddle</td>
                                <td>Bontrager Montrose Comp</td>
                            </tr>
                            <tr>
                                <td>Seatpost</td>
                                <td>Bontrager Line Elite 30.9mm</td>
                            </tr>
                            <tr>
                                <td>Seatpost length</td>
                                <td>150mm</td>
                            </tr>
                            <tr>
                                <td>Seatpost Diameter</td>
                                <td>30.9mm</td>
                            </tr>
                            <tr>
                                <td>Seatpost Clamp</td>
                                <td>34.9mm</td>
                            </tr>
                            <tr>
                                <td>Max. Tire Size</td>
                                <td>2.6 inches</td>
                            </tr>
                        </table>


                    </Container>
                </>
            )}
            <div>
                <ToastContainer />
            </div>

            <Modal open={isSignUpModalOpen} onClose={closeSignUpModal}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Paper style={{ padding: '20px', maxWidth: '500px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" gutterBottom>
                                Sign Up
                            </Typography>
                            <IconButton edge="end" color="inherit" onClick={closeSignUpModal}>
                                <CloseIcon />
                            </IconButton>

                        </div>

                        <form>
                            <TextField
                                label="Name"
                                margin="normal"
                                fullWidth
                                onChange={handleChangeSingUserName}
                            // Add other props as needed
                            />
                            <TextField
                                label="Email"
                                type="email"
                                margin="normal"
                                fullWidth
                                onChange={handleChangeSingemailName}
                            // Add other props as needed
                            />
                            <TextField
                                label="Password"
                                type="password"
                                margin="normal"
                                onChange={handleChangeSingPassword}
                                fullWidth
                            // Add other props as needed
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={headleSingUPUpModal}
                                className="login-submit-button"
                            // Add onClick or onSubmit handler
                            >
                                Sign Up
                            </Button>
                        </form>

                    </Paper>
                </div>
            </Modal>

            <Modal open={isLoginModalOpen} onClose={closeLoginModal}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Paper style={{ padding: '20px', maxWidth: '500px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" gutterBottom>
                                Login
                            </Typography>
                            <IconButton edge="end" color="inherit" onClick={closeLoginModal}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <TextField
                            label="Username"
                            fullWidth
                            value={state.value}
                            onChange={handleChangeUserName}
                        />
                        <TextField
                            label="Password"
                            type="password"
                            fullWidth
                            value={state.value}
                            onChange={handleChangePassword}
                        />
                        <Button variant="contained" color="primary" onClick={headleloginUpModal} className="login-submit-button">
                            Login
                        </Button>
                        <p className="sign-up-message">
                            Don't have an account yet? <a onClick={openSignUpModal}><u>Sign Up Here</u></a>
                        </p>
                    </Paper>
                </div>
            </Modal>
        </div>
    );
};

export default DetailsPage;
